export default function randomId(prefix?: string): string {
    const uu32: Uint32Array = new Uint32Array(1);
    const randomNumber = crypto.getRandomValues(uu32)[0];
    const result: string = prefix ? `${prefix}-${randomNumber.toString(16)}` : randomNumber.toString(16);

    return result;
}
